import afrikad_logo_png from '$assets/afrikad-logo-w220.png';
import articles_svg from '$assets/services/articles.svg';
import avis_clients_svg from '$assets/services/avis-clients.svg';
import campagnes_emails_svg from '$assets/services/campagnes-emails.svg';
import devis_centralises_svg from '$assets/services/devis-centralises.svg';
import entreprises_verifiees_svg from '$assets/services/entreprises-verifiees.svg';
import messagerie_instantanee_svg from '$assets/services/messagerie-instantanee.svg';
import prise_de_rendez_vous_en_ligne_svg from '$assets/services/prise-de-rendez-vous-en-ligne.svg';
import reseau_social_pro_svg from '$assets/services/reseau-social-pro.svg';
import visibilite_digitale_svg from '$assets/services/visibilite-digitale.svg';
import * as t from '$trans';
import type { UrlHelper } from '$lib/UrlHelper';

export type ServiceKey =
    | 'services_internet'
    | 'services_visibilite_digitale'
    | 'services_devis_centralises'
    | 'services_inbox'
    | 'services_avis_clients'
    | 'services_campagnes_emails'
    | 'services_afrikad'
    | 'services_shopping'
    | 'services_rdv_en_ligne'
    | 'services_charte_verification_entreprise'
    | 'services_reseau_social_pro'
    | 'services_land_entreprises_visibilite_digitale'
    | 'services_land_membres_emploi';

export type Service = {
    title: (_lang: string) => string;
    mobileTitle?: (lang: string) => string;
    navbarTitle?: (lang: string) => string;
    image: string;
    description?: (lang: string) => string;
    link: 'cmsCountry' | ((urlHelper: UrlHelper, lang: string) => string);
    sveltekitReload: boolean;
};

export const services: readonly Service[] = [
    {
        title: (lang: string) => t.service_page.title__visibilite_digitale({}, lang),
        description: (lang: string) => t.service_page.desc__visibilite_digitale({}, lang),
        image: visibilite_digitale_svg,
        link: (urlHelper, lang) =>
            urlHelper.withLang(lang).servicePage('services_visibilite_digitale'),
        sveltekitReload: false,
    },
    {
        title: (lang: string) => t.service_page.title__devis_centralisee({}, lang),
        description: (lang: string) => t.service_page.desc__devis_centralisee({}, lang),
        image: devis_centralises_svg,
        link: (urlHelper, lang) =>
            urlHelper.withLang(lang).servicePage('services_devis_centralises'),
        sveltekitReload: false,
    },
    {
        title: (lang: string) => t.service_page.title__inbox({}, lang),
        description: (lang: string) => t.service_page.desc__inbox({}, lang),
        image: messagerie_instantanee_svg,
        link: (urlHelper, lang) => urlHelper.withLang(lang).servicePage('services_inbox'),
        sveltekitReload: false,
    },
    {
        title: (lang: string) => t.service_page.title__avis_clients({}, lang),
        description: (lang: string) => t.service_page.desc__avis_clients({}, lang),
        image: avis_clients_svg,
        link: (urlHelper, lang) =>
            urlHelper.withLang(lang).servicePage('services_avis_clients'),
        sveltekitReload: false,
    },
    {
        title: (lang: string) => t.service_page.title__campagnes_emails({}, lang),
        description: (lang: string) => t.service_page.desc__campagnes_emails({}, lang),
        image: campagnes_emails_svg,
        link: (urlHelper, lang) =>
            urlHelper.withLang(lang).servicePage('services_campagnes_emails'),
        sveltekitReload: false,
    },
    {
        title: (lang: string) => t.service_page.title__afrikad({}, lang),
        mobileTitle: (lang: string) => t.service_page.mobile_title__afrikad({}, lang),
        navbarTitle: (lang: string) => t.service_page.navbar_title__afrikad({}, lang),
        description: (lang: string) => t.service_page.desc__afrikad({}, lang),
        image: afrikad_logo_png,
        link: (urlHelper, lang) =>
            urlHelper.withLang(lang).servicePage('services_afrikad'),
        sveltekitReload: false,
    },
    {
        title: (lang: string) => t.service_page.title__shopping({}, lang),
        navbarTitle: (lang: string) => t.service_page.mobile_title__shopping({}, lang),
        description: (lang: string) => t.service_page.desc__shopping({}, lang),
        image: articles_svg,
        link: (urlHelper, lang) =>
            urlHelper.withLang(lang).servicePage('services_shopping'),
        sveltekitReload: false,
    },
    {
        title: (lang: string) => t.service_page.title__rdv_en_ligne({}, lang),
        navbarTitle: (lang: string) =>
            t.service_page.navbar_title__rdv_en_ligne({}, lang),
        description: (lang: string) => t.service_page.desc__rdv_en_ligne({}, lang),
        image: prise_de_rendez_vous_en_ligne_svg,
        link: (urlHelper, lang) =>
            urlHelper.withLang(lang).servicePage('services_rdv_en_ligne'),
        sveltekitReload: false,
    },
    {
        title: (lang: string) => t.service_page.title__articles({}, lang),
        image: articles_svg,
        link: 'cmsCountry',
        sveltekitReload: true,
    },
    {
        title: (lang: string) =>
            t.service_page.title__charte_verification_entreprise({}, lang),
        image: entreprises_verifiees_svg,
        link: (urlHelper, lang) =>
            urlHelper
                .withLang(lang)
                .servicePage('services_charte_verification_entreprise'),
        sveltekitReload: false,
    },
    {
        title: (lang: string) => t.service_page.title__reseau_social_pro({}, lang),
        description: (lang: string) => t.service_page.desc__reseau_social_pro({}, lang),
        image: reseau_social_pro_svg,
        link: (urlHelper, lang) =>
            urlHelper.withLang(lang).servicePage('services_reseau_social_pro'),
        sveltekitReload: false,
    },
] as const;
